import * as React from "react";
import { Icon } from "../../../../Icon";
export function SoccerLiveTableHeaderColumn(props) {
    return (React.createElement("th", { className: "rj-scoreboard-poc__live-head-icon", "data-uat": "scoreboard-live-header-column" },
        React.createElement(Icon, { i: `${props.iconClass} i-12` })));
}
//# sourceMappingURL=SoccerLiveTableHeaderColumn.js.map